import styles from './Logo.module.css'

/**
 * townshop.in logo, concept 01 "Shopfront pin" (D-66): a map pin holding a shopfront with an awning,
 * then the "townshop.in" wordmark. This is the on-brand variant for the blue header: white pin, brand
 * shopfront, amber awning, "town" white, "shop" amber and ".in" white.
 */
export function Logo() {
  return (
    <span className={styles.logo}>
      <svg className={styles.mark} viewBox="0 0 120 120" aria-hidden="true">
        <path
          d="M60 114 C46 98 18 70 18 46 A42 42 0 0 1 102 46 C102 70 74 98 60 114 Z"
          className={styles.pin}
        />
        <rect x="38" y="36" width="44" height="30" rx="3" className={styles.front} />
        <rect x="54" y="48" width="12" height="18" rx="2" className={styles.pin} />
        <path
          d="M34 26 H86 V36 a6.5 6.5 0 0 1 -13 0 a6.5 6.5 0 0 1 -13 0 a6.5 6.5 0 0 1 -13 0 a6.5 6.5 0 0 1 -13 0 Z"
          className={styles.awning}
        />
      </svg>
      <span className={styles.word}>
        town<span className={styles.shop}>shop</span>.in
      </span>
    </span>
  )
}
